import axios from "axios";
import { EarnRequestV2, EarnResponseV2 } from "redmond";

import { config } from "../../config";

import { rewardsApiPrefix } from "../paths";

const END_POINT: string = `${rewardsApiPrefix}/convert/productToEarn`;

export const productToEarnV2 = async (
  request: EarnRequestV2
): Promise<EarnResponseV2> => {
  try {
    const res = await axios.put(END_POINT, request, {
      baseURL: config.baseURL,
    });

    return res.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
